import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import Button from '../../Button'

import { QA_NAME_EXPORT_TABLE_MODAL_BUTTON } from './TableModalButtonExport.constants'

import ExportIcon from '../../../icons/export.svg'

function TableModalButtonExport({
  Component = Button.Text,
  beforeIconProps: { Icon = ExportIcon, ...beforeIconProps } = EMPTY_OBJECT,
  qaName = QA_NAME_EXPORT_TABLE_MODAL_BUTTON,
  text = 'Modal.ExportBtnKey',
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <Component
      {...restProps}
      beforeIconProps={{ ...beforeIconProps, Icon }}
      qaName={qaName}
      text={t(text)}
    />
  )
}

export default TableModalButtonExport
